import { InjectionToken } from "@angular/core";
import { Route } from "@angular/router";

export const REGISTRATION_ROUTES = new InjectionToken<Route[]>('registrationRoutes', {
    providedIn: 'root',
    factory: () => []
});